import React from 'react';
import Filter from '@/components/Filter';
import DatasetAttachmentsFilterToggles from './DatasetAttachmentsFilterToggles';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentsFilters = ({ category, code, fluid }) => {
  const { filterTerm, typeFilter } = Selectors.useDatasetAttachmentsFilters({ category, code });
  const updateFlags = Events.useToggleDatasetAttachmentTypeFilter(category, { code });
  const updateTextFilter = Events.useUpdateDatasetAttachmentTextFilter(category, { code });
  return (
    <Filter
      className="aridhia-dataset-attachments-filters"
      filterTerm={filterTerm}
      fluid={fluid}
      updateFilter={({ value: text }) => updateTextFilter({ text })}
      label={(<DatasetAttachmentsFilterToggles typeFilter={typeFilter} onClick={updateFlags} />)}
    />
  );
};

export default DatasetAttachmentsFilters;
